export const columnOptions = [
  {
    label: 'Dividends',
    options: [
      {
        label: 'Transaction Date',
        value: 'date',
      },
      {
        label: 'Stock Name',
        value: 'name',
      },
      {
        label: 'Dividend Amount',
        value: 'gain',
      },
    ],
  },
  {
    label: 'Stocks',
    options: [
      {
        label: 'Purchase Date',
        value: 'purchase_date',
      },
      {
        label: 'Sale Date',
        value: 'date',
      },
      {
        label: 'Stock Name',
        value: 'name',
      },
      {
        label: 'Gain/Loss',
        value: 'gain',
      },
      {
        label: 'Cost Basis',
        value: 'cost_basis',
      },
      {
        label: 'Proceeds',
        value: 'proceeds',
      },
    ],
  },
  {
    label: 'Currency Exchange',
    options: [
      {
        label: 'Transaction date',
        value: 'date',
      },
      {
        label: 'Amount Sent (without fee)',
        value: 'cost_basis',
      },
      {
        label: 'Amount Received',
        value: 'proceeds',
      },
      {
        label: 'Fees',
        value: 'fees',
      },
    ],
  },
]
